import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import configData from "../config.json";
import Loading from "../Loading/Loading";
import { setToken, removeToken } from "../utils/auth";
import {
  handleGoogleLogin,
  handleAppleLogin,
  handleMicrosoftLogin,
  handleUsernamePasswordLogin
} from "../utils/loginOptions";
import { FcGoogle } from "react-icons/fc";
import { FaApple, FaMicrosoft } from "react-icons/fa";
import './UserLogin.css'

const UserLogIn = ({}) => {
  removeToken()
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loginLoading, setLoginLoading] = useState(false);
  const navigate = useNavigate();

  const loginWithBackend = async (idToken) => {
    if (!idToken) throw new Error("Authentication failed");

    const response = await fetch(
      `${configData.DEMO_URL}/Authentication/Login`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`
        }
      }
    );
    const data = await response.json(); // parse JSON first
    if (!response.ok) {
      throw new Error(data.message || "Server auth failed");
    }

    const expirationDate = new Date(data.exp);
    const expiresInSeconds = Math.floor(
      (expirationDate.getTime() - Date.now()) / 1000
    );

    setToken(data.token, expiresInSeconds);
    // setCurrentBalance(data.current_balance);

    navigate("/MarketingAgent");
  };

  const handleEmailPasswordSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoginLoading(true);

    try {
      const idToken = await handleUsernamePasswordLogin(email, password);
      await loginWithBackend(idToken);
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoginLoading(false);
    }
  };

  const handleProviderLogin = async (providerFn) => {
    setError(null);
    setLoginLoading(true);

    try {
      const idToken = await providerFn();
      await loginWithBackend(idToken);
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoginLoading(false);
    }
  };

    return (
    <div className="login-container">
      {loginLoading ? (
        <Loading />
      ) : (
        <div className="login-form">
          <div className="login-header">
            <img src="/favicon.ico" alt="Flavi Icon" />
          </div>

          <h1>Marketing Intelligence Agent</h1>

          {error && (
            <div className="login-error-message" role="alert">
              {error}
            </div>
          )}

          <form onSubmit={handleEmailPasswordSubmit}>
            <div className="input-group">
              <input
                type="text"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-field"
              />
            </div>

            <div className="input-group">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-field"
              />
            </div>

            <button type="submit" className="login-btn">
              Login
            </button>

            <p className="login-helper-text">version 1.0.02</p>
          </form>
          {/* Social logins – SAME CSS */}
          <div className="provider-icons">
            <FcGoogle
              className="clickable-icon"
              onClick={() => handleProviderLogin(handleGoogleLogin)}
            />
            <FaApple
              className="clickable-icon"
              onClick={() => handleProviderLogin(handleAppleLogin)}
            />
            <FaMicrosoft
              className="clickable-icon"
              onClick={() => handleProviderLogin(handleMicrosoftLogin)}
            />
          </div>


        </div>
      )}
    </div>
  );

};

export default UserLogIn;
